import { render } from "./ResultatsAgir.vue?vue&type=template&id=105d570a&scoped=true"
import script from "./ResultatsAgir.vue?vue&type=script&lang=js"
export * from "./ResultatsAgir.vue?vue&type=script&lang=js"

import "./ResultatsAgir.vue?vue&type=style&index=0&id=105d570a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105d570a"]])

export default __exports__